import { EditForm } from "./edit-form";

export const Games = { EditForm };
